import * as React from "react";
export class GameHeading extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-aggregate-matches-heading" },
            React.createElement("div", { className: "rj-aggregate-match-participant1" }, this.props.participant1.name),
            React.createElement("div", { className: "rj-aggregate-match-scores" },
                React.createElement("span", null, this.props.participant1.score),
                React.createElement("span", { className: "rj-aggregate-match-scores--separator" }, "-"),
                React.createElement("span", null, this.props.participant2.score)),
            React.createElement("div", { className: "rj-aggregate-match-participant2" }, this.props.participant2.name)));
    }
}
//# sourceMappingURL=GameHeading.js.map